/**
 * 🛡️ SENTINEL SIGNAL TRANSLATION PROTOCOL
 * Version: 1.0.0
 * Objective: Replace technical infrastructure logs (Firebase/Firestore) 
 * with branded, authoritative Sentinel Safe terminology.
 */

export const translateSentinelError = (error) => {
    if (!error) return "Registry Protocol Error: An unknown handshake failure occurred.";

    const code = error.code || '';
    const message = (error.message || '').toLowerCase();

    // --- 1. IDENTITY & AUTHORISATION HANDSHAKES ---
    if (code === 'auth/user-not-found' || message.includes('user-not-found')) {
        return "Identity Registry Mismatch: Credentials not recognized within the secure directory.";
    }
    if (code === 'auth/wrong-password' || code === 'auth/invalid-credential') {
        return "Authorisation Handshake Denied: Security Key mismatch detected.";
    }
    if (code === 'auth/email-already-in-use') {
        return "Registry Violation: This identity is already enrolled in the Sentinel directory.";
    }
    if (code === 'auth/weak-password') {
        return "Security Protocol Failure: Provided Access Key does not meet complexity requirements.";
    }
    if (code === 'auth/too-many-requests') {
        return "Registry Lockout: Excessive attempts detected. Secure tunnel temporarily suspended.";
    }
    if (code === 'auth/user-disabled') {
        return "Clearance Revoked: This member account has been decommissioned by an Administrator.";
    }
    if (code === 'auth/requires-recent-login' || message.includes('recent-login')) {
        return "Security Re-authentication Required: Please re-establish your session to perform this high-stakes update.";
    }

    // --- 2. DATA ACCESS & CLEARANCE (FIRESTORE) ---
    if (code === 'permission-denied' || message.includes('permission-denied')) {
        return "Security Clearance Violation: Your current Access Tier does not permit this protocol.";
    }
    if (code === 'not-found' || message.includes('not-found')) {
        return "Registry Sync Failure: The requested operational record does not exist.";
    }
    if (code === 'unavailable' || message.includes('unavailable')) {
        return "Transmission Interrupted: The Sentinel Registry is currently offline for maintenance.";
    }
    if (code === 'deadline-exceeded') {
        return "Synchronisation Timeout: The secure handshake exceeded the permitted response window.";
    }

    // --- 3. ATOMIC TRANSMISSION & STORAGE ---
    if (message.includes('storage/unauthorized') || message.includes('storage/forbidden')) {
        return "Atomic Transmission Failure: Document seal protocol denied.";
    }
    if (message.includes('storage/retry-limit-exceeded')) {
        return "Transmission Failure: Connectivity too unstable to synchronise document registry.";
    }

    // --- 4. CLOUD FUNCTION HANDSHAKES ---
    if (message.includes('unauthenticated')) {
        return "Secure Handshake Required: Your session has expired. Please re-authenticate.";
    }

    // --- 5. NETWORK & GENERAL FAILBACK ---
    if (message.includes('network-request-failed') || message.includes('offline')) {
        return "Transmission Interrupted: Registry Synchronisation Offline. Check your data link.";
    }

    // Branded Default Fallback
    return `Registry Protocol Alert: ${error.message || 'A secure handshake could not be completed.'}`;
};